import { Record as record } from 'immutable';
import joi from 'joi';
import moment from 'moment';

import { translate as t } from '../../lib/I18n';
import { KEYGO_NICKNAME } from '../../constants/AppConstants';
import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';


const defaults = {
    showCollectionLocation: false,
    collectionLocation: null,
    nickname: KEYGO_NICKNAME,
    cardHolderName: null,
    cardNumber: null,
    expiryMonth: null,
    expiryYear: null,
    cv2: null,
    addressLine1: null,
    addressLine2: null,
    addressLine3: null,
    townCity: null,
    postcode: null,
    country: 'GBR'
};


class KeyGoForm extends record(defaults) {

    getComputedValues () {
        const expiryMonth = parseInt(this.expiryMonth, 10);
        const expiryYear = parseInt(this.expiryYear, 10);
        const isExpired = moment().isAfter(moment(`${expiryMonth}-${expiryYear}`, 'MM-YYYY').endOf('month'));
        return {
            isExpired: Boolean(expiryMonth) && Boolean(expiryYear) && isExpired
        };
    }

    getSchema () {
        return {
            collectionLocation: validators.collectionLocation(this.showCollectionLocation),
            cardHolderName: validators.cardHolderName(),
            cardNumber: validators.cardNumber(),
            expiryMonth: validators.expiryMonth(),
            expiryYear: validators.expiryYear(),
            cv2: validators.cv2(),
            addressLine1: validators.addressLine().required(),
            townCity: validators.townCity(),
            postcode: validators.postcode(),
            country: validators.country(),
            isExpired: joi.boolean().optional().only(false).options({
                language: {
                    any: {
                        allowOnly: t('alertmessage.cardExpired')
                    }
                }
            })
        };
    }

}

Object.assign(KeyGoForm.prototype, ValidationMixin);

export default KeyGoForm;



// WEBPACK FOOTER //
// ./src/records/customer/KeyGoForm.js